import * as React from "react";
import {Row, Col, Typography, Divider, Form, DatePicker} from "antd";
import {InnerTabs, MyBreadcrumb, MyButton, MyInput, MyPassword, MySelect, OuterTabs} from "../../components";
import {useTheme} from "../../hooks";
import {useCallback} from "react";

export const Profile = (): React.ReactElement => {
  const {themeConfig} = useTheme()

  const onFinishMain = useCallback((values: any) => {
    console.log('values', values)
  }, [])

  const onFinishPassword = useCallback((values: any) => {
    console.log('values', values)
  }, [])


  const items = [
    {
      key: '1',
      label: 'Личные данные',
      children: (
        <Row  style={{padding: '16px 24px'}}>
          <Col span={24}>
            <Form onFinish={onFinishMain} layout='vertical' name='main'>
              <Row align='middle' gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    label="Имя"
                    name="name"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    required={true}
                  >
                    <MyInput placeholder='Введите имя'/>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label="Фамилия"
                    name="surname"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    required={true}
                  >
                    <MyInput placeholder='Введите фамилию'/>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Отчество (при наличии)"
                    name="middlename"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                  >
                    <MyInput placeholder='Введите отчество'/>
                  </Form.Item>
                </Col>
              </Row>
              <Row align='middle' gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    label="Дата рождения"
                    name="birth"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    required={true}
                  >
                    <DatePicker style={{width: '100%'}}/>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label="Место работы"
                    name="work"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    required={true}
                  >
                    <MySelect placeholder='Выберите из списка'>

                    </MySelect>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Должность"
                    name="position"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                  >
                    <MySelect placeholder='Выберите из списка'>

                    </MySelect>
                  </Form.Item>
                </Col>
              </Row>

              <Row justify='center' align='middle' gutter={[16, 16]}>
                <Col>
                  <MyButton ghost height={40} type="primary" htmlType="submit" title='Сохранить'/>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      ),
    },
    {
      key: '2',
      label: 'Смена пароля',
      children: (
        <Row  style={{padding: '16px 24px'}}>
          <Col span={24}>
            <Form onFinish={onFinishPassword} layout='vertical' name='password'>
              <Row align='middle' gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    label="Текущий пароль"
                    name="password1"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                  >
                    <MyPassword/>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label="Новый пароль"
                    name="password2"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                  >
                    <MyPassword/>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Подтверждение пароля"
                    name="password3"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                  >
                    <MyPassword/>
                  </Form.Item>
                </Col>
              </Row>
              <Row justify='center' align='middle' gutter={[16, 16]}>
                <Col>
                  <MyButton ghost height={40} type="primary" htmlType="submit" title='Сохранить'/>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <>
      <MyBreadcrumb title="Редактирование профиля" isBack/>

      <Row justify='center'>
        <Col span={20}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div style={{
                borderRadius: 4,
                overflow: 'hidden',
              }}>
                <InnerTabs items={items}/>
              </div>
            </Col>

            {/*<Col span={24}>*/}
            {/*  <div style={{*/}
            {/*    borderRadius: 4,*/}
            {/*    overflow: 'hidden'*/}
            {/*  }}>*/}
            {/*    <OuterTabs items={items}/>*/}
            {/*  </div>*/}
            {/*</Col>*/}
          </Row>
        </Col>
      </Row>
    </>

  )
}